import DataTable from '@/containers/data_table_ml/DataTable';
import { CONSTANT } from '../../constant/index';

const TablePage = (props) => {
  const { loadingstatus, tableData } = props || {};
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      title: '模型名称',
      dataIndex: 'name',
      key: 'name',
      // width: 140,
    },
    {
      title: '操作人员',
      dataIndex: 'operator',
      key: 'operator',
      // width: 100,
    },
    {
      title: '操作类型',
      dataIndex: 'operationType',
      key: 'operationType',
      // width: 100,
      render: (recor) => {
        const result = CONSTANT.operationTypeList.find(
          (item) => item.name === recor,
        );
        if (result) {
          return result.name ? result.value : '';
        }
        return recor;
      },
    },
    {
      title: '操作详情',
      dataIndex: 'operationDetails',
      key: 'operationDetails',
      // width: 100,
    },
  ];
  return (
    <>
      <DataTable
        className="demo-test"
        style={{ minWidth: '1547px' }}
        columns={columns}
        rowSelection={false}
        scroll={{ y: 'calc(100vh - 156px - 3rem)' }}
        loading={loadingstatus}
        dataSource={tableData}
        changePage={(a) => {
          props.pageNumChange(a);
        }}
        changePageSize={(a) => {
          props.pageSizeChange(a);
        }}
      />
    </>
  );
};
export default TablePage;
